<template>
    <div class="voiceRec-container">
        <div v-if="!isLoad" class="btn">
            <p v-if="hasResult && !data.isStream" @click="convertWord(data)">重新识别</p>
            <p v-if="hasResult" :class="{on: data.isStream}" @click="exportText">导出文字</p>
            <p v-if="hasResult" :class="{on: data.isStream}" @click="copyText">复制文字</p>
            <p v-if="!hasResult && !data.isStream" class="full" @click="convertWord(data)">重新识别</p>
            <input style="position: absolute; top: -100000000000px" ref="wordList" type="text">
        </div>
        <div v-if="hasResult" class="search-container">
            <input v-model="wordInput" placeholder="请输入关键词" type="text">
            <i @click="filterWord" class="search"></i>
        </div>
        <ul v-if="hasResult">
            <li @click="toTime(item.bg)" v-for="(item,index) in wordList" :key="index" class="on">
                <p class="left">{{item.begin}}</p>
                <p v-html="item.onebest" class="right"></p>
            </li>
        </ul>
        <newMaterialLoad v-if="!hasResult&&isLoad"></newMaterialLoad>
        <newMaterialNoResult v-if="!hasResult&&!isLoad"></newMaterialNoResult>
    </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";

export default {
    name: 'newMaterialVoiceRec',
    data() {
        return {
            hasResult: false,
            isLoad: true,
            wordList: [],
            saveWordList: [],
            wordContent: '',
            wordInput: ''
        }
    },
    props: {
        data: {
            type: Object
        },
        keywords: {
            type: String
        }
    },
    methods: {
        toTime(s) {
            this.$emit('toTime', s)
        },
        convertWord(f) {
            // 音视频转文字
            if ((!f.content || f.content.status != 1) && f.type != 3) {
                this.$toast("转码中，暂时无法转文字");
                return;
            }

            const info = {
                idstring: f.idstring
            };

            common.myFetch(apis.File_convert, info).then(r => {
                if (r) {
                    this.$toast(r);
                    this.hasResult = false;
                    this.isLoad = true;
                    this.$emit('voiceStatus',2)
                }
            });
        },
        getTranstext(r) {
            this.$emit('clickFun')
            console.log('getTranstext r', r)
            // 获取转文字状态
            this.$toast("转文字完成");
            this.getWordList();
        },
        getWordList() {
            const info = {
                idstring: this.data.idstring,
                keywords: this.keywords ? this.keywords : ''
            };

            common.myFetch(apis.File_getWord, info).then(r => {
                if (r) {
                    console.log(r)
                    this.data.text_status = 3;
                    if(r.res.length > 0){
                        this.wordContent = r.content;
                        this.wordList = r.res;
                        // this.wordList = [{
                        //     begin: '123',
                        //     onebest: 123
                        // }];
                        this.saveWordList = r.res;
                        this.hasResult = true;
                        this.isLoad = false;
                    }else{
                        this.hasResult = false;
                        this.isLoad = false;
                    }
                }else{
                    this.data.text_status = 4;
                    this.hasResult = false;
                    this.isLoad = false;
                }
            });
        },
        copyText() {
            if (this.wordList.length === 0) return false;
            const wordListDom = this.$refs.wordList;
            wordListDom.value = this.wordContent;
            wordListDom.select();
            // 执行浏览器复制命令
            document.execCommand("Copy");
            this.$toast("复制成功");
        },
        beforeunload_normal(e) {
            console.log("beforeunload_normal", e);
            const event = e || window.event;
            return (event.returnValue = true);
        },
        exportText() {
            if (this.wordList.length === 0) return false;
            const info = {
                idstring: this.data.idstring,
                type: 2
            };

            // info.paragraphs = this.wordList
            //     .filter(i => i.selected)
            //     .map(j => j.o)
            //     .join(",");

            const userKeys = common.userKeys();
            const params = Object.assign({}, info, userKeys);

            window.removeEventListener(
                "beforeunload",
                this.beforeunload_normal
            )

            common.exportRes(apis.File_expTxt, params);
        },
        filterWord() {
            if(this.wordInput){
                let wordList = this.wordList;
                this.wordList = wordList.filter(el => {
                    if(el.onebest.indexOf(this.wordInput) > -1){
                        return el
                    }
                })
            }else{
                this.wordList = this.saveWordList
            }
        }
    },
    mounted() {
        if(this.data.isStream){
            if(this.data.audiorec_res.result.length > 0){
                this.wordContent = this.data.audiorec_res.content;
                this.wordList = this.data.audiorec_res.result;
                // this.wordList = [{
                //     begin: '123',
                //     onebest: 123
                // }];
                this.saveWordList = this.data.audiorec_res.result;
                this.hasResult = true;
                this.isLoad = false;
            }else{
                this.hasResult = false;
                this.isLoad = false;
            }
        }else{
            common.handleSocket(this.getTranstext, "pickuptext");
            console.log(this.data)
            if(this.data.text_status-0 === 1){
                this.convertWord(this.data)
            }else if(this.data.text_status-0 === 3 || this.data.text_status-0 === 4){
                this.getWordList()
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .voiceRec-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 14px 20px 0;
        box-sizing: border-box;

        .btn {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 14px;

            .on {
                width: 165px;
            }

            p.full {
                width: 356px;
                height: 32px;
                background: #41B48C;
                border-radius: 4px;
                line-height: 32px;
                font-size: 14px;
                color: #fff;
            }

            p {
                width: 112px;
                height: 32px;
                line-height: 32px;
                font-size: 14px;
                color: #41B48C;
                border-radius: 4px;
                border: 1px solid #41B48C;
                box-sizing: border-box;
                text-align: center;
                user-select: none;
                cursor: pointer;

                &:hover {
                    background: #41B48C;
                    color: #FFF;
                }
            }
        }

        .search-container {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            height: 40px;
            background: rgba(207, 215, 219, 0.2);
            border-radius: 6px;
            padding: 0 20px;
            box-sizing: border-box;
            margin-bottom: 14px;

            input {
                flex: 1;
                height: 40px;
                background: transparent;
                border: none;
                outline: none;
                
                &::placeholder {
                    color: #B9C3C3;
                }
            }

            i {
                display: block;
                width: 14px;
                height: 14px;
                background: url('../../../common/newMaterialBox/assets/search.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                user-select: none;
                cursor: pointer;
            }
        }

        ul {
            display: flex;
            flex-direction: column;
            flex: 1;
            min-height: 0;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 6px;
            }
            &::-webkit-scrollbar-thumb {
                background: rgba(#D8D8D8, 1);
                border-radius: 5px;
            }

            li {
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 14px;
                color: #050F0F;
                user-select: none;
                cursor: pointer;

                &:nth-last-of-type(1) {
                    margin-bottom: 0;
                }

                &:hover {
                    color: #41B48C;
                }

                // &.on {
                //     color: #41B48C;
                // }

                .left {
                    width: 58px;
                    margin-right: 16px;
                    font-size: 14px;
                    line-height: 20px;
                }

                .right {
                    display: flex;
                    flex-wrap: wrap;
                    flex: 1;
                    font-size: 14px;
                    line-height: 20px;
                }
            }
        }
    }
</style>

<style lang="less">
.voiceRec-container {
    em {
        color: #41b48c;
        font-style: normal;
    }
}
</style>